import React from 'react';
import { Icon, IconProps } from './Icon';

export const ChevronBottomIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon viewBox="0 0 12 8" {...props}>
      <path
        d="M1 1.5L5.41074 6.23782C5.73618 6.58739 6.26382 6.58739 6.58926 6.23782L11 1.5"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  );
};
